import * as yup from 'yup'
import {DefaultDescriptionValidation, defaultImageValidation, DefaultNameValidation} from '../../configs/constants'

export const albumInputSchema = yup.object({
    name: DefaultNameValidation().required(),
    description: DefaultDescriptionValidation().required(),
    image: defaultImageValidation,
})
